<template>
  <div class="channel-note-list">
    <!-- 用户信息 -->
    <el-card class="user-info-card" shadow="never">
      <div slot="header">
        <span>用户信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="info-item">
            <label>公司名称：</label>
            <span>{{ userInfo.company_name || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <label>用户手机号：</label>
            <span>{{ userInfo.mobile || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <label>注册时间：</label>
            <span>{{ formatDate(userInfo.created_at) || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 操作按钮 -->
    <div class="action-bar">
      <el-button type="primary" @click="showAddDialog">添加备注</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>

    <!-- 备注列表 -->
    <el-table :data="noteList" v-loading="loading" border>
      <el-table-column prop="product" label="产品" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ getProductName(scope.row.product) }}
        </template>
      </el-table-column>
      <el-table-column prop="order_id" label="订单号" width="150" show-overflow-tooltip />
      <el-table-column prop="policy_no" label="保单号" width="150" show-overflow-tooltip />
      <el-table-column prop="content" label="备注内容" min-width="200" show-overflow-tooltip />
      <el-table-column prop="type" label="备注类型" width="100">
        <template slot-scope="scope">
          {{ getNoteTypeName(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="file_urls" label="备注图片" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.file_urls && Array.isArray(scope.row.file_urls) && scope.row.file_urls.length > 0" class="image-list">
            <el-image
              v-for="(url, index) in scope.row.file_urls"
              :key="index"
              class="image-item"
              style="width: 40px; height: 40px; margin-right: 5px; margin-bottom: 5px;"
              :src="url"
              :preview-src-list="scope.row.file_urls"
              fit="cover">
            </el-image>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="160">
        <template slot-scope="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" width="160">
        <template slot-scope="scope">
          {{ formatDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="username" label="备注人用户名" width="120" />
      <el-table-column prop="realname" label="备注人真实姓名" width="120" />
      <el-table-column prop="mobile" label="备注人手机号" width="120" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editNote(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteNote(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 添加/编辑备注对话框 -->
    <el-dialog :title="isEdit ? '编辑备注' : '添加备注'" :visible.sync="addDialogVisible" width="600px">
      <el-form :model="noteForm" :rules="noteRules" ref="noteForm" label-width="100px">
        <template>
          <el-form-item label="备注类型" prop="type">
            <el-select v-model="noteForm.type" placeholder="请选择备注类型" style="width: 100%">
              <el-option label="理赔" value="1"></el-option>
              <el-option label="软件" value="2"></el-option>
              <el-option label="费用" value="4"></el-option>
              <el-option label="优惠" value="8"></el-option>
              <el-option label="其他" value="16"></el-option>
            </el-select>
          </el-form-item>
        </template>
        
        <el-form-item label="备注内容" prop="note_content">
          <el-input
            type="textarea"
            v-model="noteForm.note_content"
            :rows="4"
            placeholder="请输入备注内容">
          </el-input>
        </el-form-item>
        <el-form-item label="备注图片">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleImageSuccess"
            :before-upload="beforeImageUpload"
            :on-remove="handleImageRemove"
            :file-list="fileList"
            list-type="picture"
            name="fileVal"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持多张图片上传，只能上传jpg/png文件，每张图片不超过2MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitNote" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
 export default {
   name: 'ChannelNoteList',
   data() {
     return {
       userId: '',
       userInfo: {},
       noteList: [],
       loading: false,
       submitting: false,
       addDialogVisible: false,
       isEdit: false,
       currentEditId: null,
       fileList: [],
       pagination: {
         page: 1,
         limit: 20,
         total: 0
       },
       noteForm: {
         product_name: '',
         order_no: '',
         policy_no: '',
         type: '',
         note_content: '',
         file_urls: []
       },
       noteRules: {
         type: [
           { required: true, message: '请选择备注类型', trigger: 'change' }
         ],
         note_content: [
           { required: true, message: '请输入备注内容', trigger: 'blur' }
         ]
       },
       uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
       uploadHeaders: {
         'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
       }
     }
   },
   created() {
     this.userId = this.$route.query.id
     if (this.userId) {
       this.loadUserInfo()
       this.loadNoteList()
     }
   },
   methods: {
     // 加载用户信息
     async loadUserInfo() {
       try {
         const res = await this.$api.note.getUserInfo({ id: this.userId })
         if (res.err_code === 0) {
           this.userInfo = res.data
         }
       } catch (error) {
         console.error('加载用户信息失败:', error)
       }
     },
     
     // 加载备注列表
     async loadNoteList() {
       try {
         this.loading = true
         const params = {
           user_id: this.userId,
           page: this.pagination.page,
           limit: this.pagination.limit
         }
         const res = await this.$api.note.getNoteList(params)
         if (res.err_code === 0) {
           this.noteList = res.rows || []
           this.pagination.total = res.total || 0
         }
       } catch (error) {
         console.error('加载备注列表失败:', error)
         this.$message.error('加载备注列表失败')
       } finally {
         this.loading = false
       }
     },
     
     // 显示添加对话框
     showAddDialog() {
       this.isEdit = false
       this.currentEditId = null
       this.noteForm = {
         product_name: '',
         order_no: '',
         policy_no: '',
         type: '',
         note_content: '',
         file_urls: []
       }
       this.fileList = []
       this.addDialogVisible = true
     },
     
     // 编辑备注
     editNote(row) {
       this.isEdit = true
       this.currentEditId = row.id
       // 编辑时只设置可编辑的字段，产品相关字段保持空值
       this.noteForm = {
         product_name: '',
         order_no: '',
         policy_no: '',
         type: row.type ? String(row.type) : '',
         note_content: row.content || '',
         file_urls: (row.file_urls && Array.isArray(row.file_urls)) ? [...row.file_urls] : []
       }
       // 设置文件列表
       this.fileList = (row.file_urls && Array.isArray(row.file_urls) && row.file_urls.length > 0) ? 
         row.file_urls.map((url, index) => ({
           name: `备注图片${index + 1}`,
           url: url
         })) : []
       this.addDialogVisible = true
     },
     
     // 提交备注
     async submitNote() {
       this.$refs.noteForm.validate(async (valid) => {
         if (valid) {
           try {
             this.submitting = true
             const data = {
               type: this.noteForm.type*1,
               content: this.noteForm.note_content,
               file_urls: this.noteForm.file_urls
             }
             
             // 新增时需要包含产品相关字段
             if (!this.isEdit) {
               data.user_id = this.userId*1;
               data.product = 1;
             }
             
             let res
             if (this.isEdit) {
               // 编辑备注
               data.id = this.currentEditId
               res = await this.$api.note.updateNote(data)
             } else {
               // 添加备注
               res = await this.$api.note.addNote(data)
             }
             
             if (res.err_code === 0) {
               this.$message.success(this.isEdit ? '编辑备注成功' : '添加备注成功')
               this.addDialogVisible = false
               this.loadNoteList()
             } else {
               this.$message.error(res.data.msg || (this.isEdit ? '编辑备注失败' : '添加备注失败'))
             }
           } catch (error) {
             console.error('提交备注失败:', error)
             this.$message.error(this.isEdit ? '编辑备注失败' : '添加备注失败')
           } finally {
             this.submitting = false
           }
         }
       })
     },
     
     // 删除备注
     async deleteNote(row) {
       this.$confirm('确定要删除这条备注吗？', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(async () => {
         try {
           const res = await this.$api.note.deleteNote({ id: row.id })
           if (res.err_code === 200) {
             this.$message.success('删除成功')
             this.loadNoteList()
           } else {
             this.$message.error(res.data.msg || '删除失败')
           }
         } catch (error) {
           console.error('删除备注失败:', error)
           this.$message.error('删除失败')
         }
       })
     },
     
     // 图片上传成功回调
     handleImageSuccess(response, file) {
       if (response.err_code === 0) {
         // 确保 file_urls 是数组
         if (!Array.isArray(this.noteForm.file_urls)) {
           this.noteForm.file_urls = []
         }
         // 将新上传的图片URL添加到数组中
         this.noteForm.file_urls.push(response.data)
         this.$message.success('图片上传成功')
       } else {
         this.$message.error(response.err_msg || '图片上传失败')
       }
     },
     
     // 图片上传前验证
     beforeImageUpload(file) {
       const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
       const isLt2M = file.size / 1024 / 1024 < 2
       
       if (!isJPG) {
         this.$message.error('上传图片只能是 JPG/PNG 格式!')
       }
       if (!isLt2M) {
         this.$message.error('上传图片大小不能超过 2MB!')
       }
       return isJPG && isLt2M
     },
     
     // 删除图片
     handleImageRemove(file, fileList) {
       // 从 file_urls 数组中移除对应的URL
       if (file.url && Array.isArray(this.noteForm.file_urls)) {
         const index = this.noteForm.file_urls.indexOf(file.url)
         if (index > -1) {
           this.noteForm.file_urls.splice(index, 1)
         }
       }
       this.$message.success('图片删除成功')
     },
     
     // 取消对话框
     cancelDialog() {
       // 重置表单
       this.$refs.noteForm.resetFields()
       this.noteForm.file_urls = []
       this.fileList = []
       this.addDialogVisible = false
     },
     
     // 获取备注类型名称
     getNoteTypeName(type) {
       const typeMap = {
         '1': '理赔',
         '2': '软件',
         '4': '费用',
         '8': '优惠',
         '16': '其他'
       }
       return typeMap[type] || '未知'
     },
     getProductName(product){
      const productMap = {
         '1': '平台',
         '2': '整车保',
         '4': '员工保',
         '8': '无忧保',
         '16': '商铺保',
         '32': '普货保',
       }
       return productMap[product] || '未知'
     },
     
     // 分页处理
     handleSizeChange(val) {
       this.pagination.limit = val
       this.pagination.page = 1
       this.loadNoteList()
     },
     
     handleCurrentChange(val) {
       this.pagination.page = val
       this.loadNoteList()
     },
     
     // 返回
     goBack() {
       this.$router.go(-1)
     },
     
     // 格式化日期
     formatDate(dateStr) {
       if (!dateStr) return ''
       
       const date = new Date(dateStr)
       if (isNaN(date.getTime()) || date.getFullYear() === 1) return ''
       
       const year = date.getFullYear()
       const month = String(date.getMonth() + 1).padStart(2, '0')
       const day = String(date.getDate()).padStart(2, '0')
       const hours = String(date.getHours()).padStart(2, '0')
       const minutes = String(date.getMinutes()).padStart(2, '0')
       const seconds = String(date.getSeconds()).padStart(2, '0')
       
       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
     }
   }
 }
 </script>

<style scoped>
.channel-note-list {
  padding: 20px;
}

.user-info-card {
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 10px;
}

.info-item label {
  font-weight: bold;
  color: #606266;
}

.action-bar {
  margin-bottom: 20px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 140px;
}

.image-item {
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s;
}

.image-item:hover {
  transform: scale(1.1);
}
</style>